import Page from "./Page";
import PageGroup, { fixedPageGroupTags } from "./PageGroup";
import { PageTypes } from "./PageTypes";
import { itx } from "../translationItx/itx";

/** Store one original PDF using the existing document/blob persistence, never once per floor. */
export function createBuildingPlanDocument(fileName: string, bytes: Uint8Array): Page {
  let group = state.pageGroups.findFirst((candidate) => candidate.tag === fixedPageGroupTags.buildingPlans);
  if (!group) {
    group = new PageGroup(
      { name: itx("pageDocumentType.buildingPlans", "Gebäudepläne"), tag: fixedPageGroupTags.buildingPlans },
      state.pageGroups,
    );
    state.pageGroups.add(group);
  }
  let number = group.pages.size + 1;
  while (group.pages.findFirst((page) => page.tag === String(number).padStart(2, "0"))) number++;
  const page = new Page({ name: fileName.replace(/\.pdf$/i, ""), tag: String(number).padStart(2, "0") }, group);
  page.documentType.type = PageTypes.pdf;
  page.documentType.name = PageTypes.pdf;
  page.pdfFile.pdfData = bytes.slice();
  page.pdfFile.needstoBeSaved = true;
  group.pages.add(page);
  page.markAsDirty();
  group.raiseOnChange("childCollection");
  return page;
}
